import {htmlLoading} from "./global";

$(document).ready(function () {
    var order_view = $('.recipe-order-page');
    if (!order_view.length) {
        return;
    }

    // order from recipe
    var update_cart_product = function(product, data) {

        product.toggleClass('in-cart', (data.product_number > 0));

        var realPackaging = null;
        var packagingGrams = data.packaging_quantity * 1000;

        var grams = packagingGrams < 1000
            ? `${data.product_number} x ${data.packaging_quantity} ${data.packaging}`
            : `${data.product_number} ${data.packaging}`;
        product.find('.item-quantity-sum').text(grams);

        product.find('.quantity-cart-total .sum').text(data.product_total);
        product.attr('data-cart-quantity', data.product_number);

        // refresh this unit's option so a later switch back reads its real cart qty
        product.find('.packaging-selector .dropdown-menu a[data-value="' + product.attr('data-packaging') + '"]')
            .attr('data-cart-quantity', data.product_number)
            .attr('data-cart-total', data.product_total);

        var quantity_input = product.find('input.quantity');

        if (data.product_number > 0) {
            quantity_input.val(data.product_number);
        } else {
            quantity_input.val(product.attr('data-quantity'));
        }
        quantity_input.data('current-value', quantity_input.val());

        var shop = product.closest('.shop');
        shop.toggleClass('cart-empty', (data.products_number == 0));
        shop.find('.cart-product-number').text(data.products_number_txt);
    };

    var update_quantity = function(product) {
        clearTimeout(product.data('updateTimeout'));
        product.data('updateTimeout', setTimeout(function() {
            var input_quantity = product.find('.item-order input.quantity'),
                val = input_quantity.val();

            if (val == input_quantity.data('current-value')) {
                return;
            }

            $.ajax({
                url: product.find('.plus-minus').attr('data-url'),
                type: 'post',
                data: {
                    quantity: val,
                    packaging: product.attr('data-packaging')
                },
                beforeSend: function() {
                    product.find('.order-action').addClass('is-loading disabled');
                },
                success: function(data) {
                    update_cart_product(product, data);
                },
                complete: function() {
                    product.find('.order-action').removeClass('is-loading disabled');
                }
            });
        }, 400));

        return false;
    };

    // each unit is its own cart line, so show the switched-to unit's cart state
    var apply_packaging = function(product, packaging, option) {
        product.attr('data-packaging', packaging);

        var suggestedQuantity = option ? $(option).attr('data-suggested-quantity') : null,
            cartQuantity = option ? parseFloat($(option).attr('data-cart-quantity')) || 0 : 0,
            cartTotal = option ? $(option).attr('data-cart-total') : null,
            unit = option ? $(option).attr('data-unit') : null;

        var orderQuantity = cartQuantity > 0 ? cartQuantity : suggestedQuantity;

        var add_link = product.find('.add-product-from-recipe');
        var href = add_link.attr('href');
        if (href) {
            href = href.replace(/([?&]packaging=)[^&]*/, '$1' + encodeURIComponent(packaging));
            if (orderQuantity) {
                href = href.replace(/([?&]quantity=)[^&]*/, '$1' + encodeURIComponent(orderQuantity));
            }
            add_link.attr('href', href);
        }

        product.attr('data-cart-quantity', cartQuantity);
        product.toggleClass('in-cart', cartQuantity > 0);

        var quantity_input = product.find('.item-order input.quantity');
        quantity_input.val(cartQuantity > 0 ? cartQuantity : (suggestedQuantity || product.attr('data-quantity')));
        quantity_input.data('current-value', quantity_input.val());

        if (cartTotal != null) {
            product.find('.quantity-cart-total .sum').text(cartTotal);
        }
        if (unit) {
            product.find('.item-quantity-sum').text(cartQuantity + ' ' + unit);
        }
    };

    $('body').on('change', '.product .packaging-selector input[name="packaging"]', function(e, option) {
        apply_packaging($(this).closest('.product'), $(this).val(), option);
    });

    // add product to cart (＋ Add) — initialises qty to 1 if empty
    $('body').on('click', '.add-product-from-recipe', function() {
        var $this = $(this), product = $this.closest('.product');

        $.ajax({
            url: $this.attr('href'),
            dataType: 'json',
            beforeSend: function() {
                $this.addClass('is-loading disabled');
            },
            success: function(data) {
                update_cart_product(product, data);
            },
            complete: function() {  // clear the spinner even on error (e.g. no order permission → modal)
                product.find('.order-action').removeClass('is-loading disabled');
            }
        });
        return false;
    });

    // ✓ In cart → remove the line from the cart (qty 0)
    $('body').on('click', '.product .overwrite-product-from-recipe', function() {
        var product = $(this).closest('.product');
        product.find('.item-order input.quantity').val(0);
        update_quantity(product);
        return false;
    });

    // plus/minus stepper
    $('body').on('click', '.product .plus-minus[data-url] a', function() {
        var $this = $(this),
            product = $this.closest('.product'),
            input_quantity = $this.closest('.plus-minus').find('input.quantity'),
            quantity = parseInt(input_quantity.val(), 10) || 0;

        quantity += $this.hasClass('plus-icon') ? 1 : -1;
        if (quantity < 0) {
            quantity = 0;
        }

        input_quantity.val(quantity);
        update_quantity(product);
    });

    $('body')
        .on('blur', '.product .plus-minus input.quantity', function() {
            update_quantity($(this).closest('.product'));
        })
        .on('keydown', '.product .plus-minus input.quantity', function(e) {
            if (e.which == 13) {    // enter
                $(this).blur();
                return false;
            }
        });

    // portions change
    $('body').on('keydown keyup keypress', 'persons input', function() {
        var $this = $(this), 
            url = $this.attr('data-url'), 
            val = $this.val();

        clearTimeout($this.data('updatePersons'));

        if (val > 0) {
            $this.data('updatePersons', setTimeout(function() {
                $.ajax({
                    url: url,
                    data: {
                        portions: $this.val() 
                    },
                    beforeSend: function() {
                        htmlLoading();
                    },
                    success: function(data) {
                        $('.recipe-order').replaceWith(data);

                        $('.recipe-order .product.in-cart').each(function() {
                            var $this = $(this);

                            if ($this.attr('data-quantity') != $this.attr('data-cart-quantity')) {
                                $this.find('.quantity-in-cart .quantity').blinkMe();
                            }
                        })
                    }
                })
            }, 400));
        }
    });

    ////////////////////////
    // end of document ready
});

